// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__3ac-_","inOut":"Notification_inOut__CLqaR","msg":"Notification_msg___OLB4","icon":"Notification_icon__3VQO9"};